import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/ep-27-awadesh-jha-guestz.webp";
import ThumbImg from "../../assets/images/conversations/027.webp";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";

/* ─────────────────────────────────────────────
   PREFIX: aj2-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .aj2-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }
  .aj2-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  /* ── HERO ── */
  .aj2-hero { padding-top: 60px; padding-bottom: 60px; }
  .aj2-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .aj2-hero__left { display: flex; flex-direction: column; gap: 44px; }
  .aj2-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .aj2-hero__title.aj2-visible { opacity: 1; transform: translateY(0); }
  .aj2-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .aj2-hero__spotify.aj2-visible { opacity: 1; transform: translateY(0); }
  .aj2-hero__spotify iframe {
    display: block; width: 100%; height: 152px; border: none; border-radius: 12px;
  }
  .aj2-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .aj2-hero__right.aj2-visible { opacity: 1; transform: translateY(0); }

  /* ── YOUTUBE THUMB ── */
  .aj2-yt-thumb {
    position: relative; width: 100%; border-radius: 12px;
    overflow: hidden; cursor: pointer; display: block; background: #000;
  }
  .aj2-yt-thumb img {
    width: 100%; height: auto; display: block;
    border-radius: 12px; transition: opacity 0.3s ease;
  }
  .aj2-yt-thumb:hover img { opacity: 0.85; }
  .aj2-yt-thumb__play {
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    background: none; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    pointer-events: none;
  }
  .aj2-yt-thumb__play img { width: 40px; height: 44px; }
  .aj2-yt-iframe-wrap {
    position: relative; width: 100%; padding-bottom: 56.25%;
    height: 0; border-radius: 12px; overflow: hidden;
  }
  .aj2-yt-iframe-wrap iframe {
    position: absolute; top: 0; left: 0;
    width: 100%; height: 100%; border: none;
  }

  /* ── BODY ── */
  .aj2-body {
    padding-bottom: 100px; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .aj2-body.aj2-visible { opacity: 1; transform: translateY(0); }
  .aj2-body__para {
    font-family: 'Roboto', sans-serif; font-size: 16px;
    font-weight: 400; color: #E2E2E2; line-height: 160%; margin-bottom: 14px;
  }
  .aj2-body__para:last-child { margin-bottom: 0; }

  /* ── GUEST ── */
  .aj2-guest {
    padding-bottom: 100px; text-align: center; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .aj2-guest.aj2-visible { opacity: 1; transform: translateY(0); }
  .aj2-guest__title {
    font-family: 'Montserrat', sans-serif; font-size: 50px;
    font-weight: 700; color: #ffffff; margin-bottom: 60px;
  }
  .aj2-guest__photo-bg {
    display: inline-block; width: 445px; height: 500px;
    background: #743FAC; border-radius: 12px; overflow: hidden;
  }
  .aj2-guest__photo-bg img {
    width: 100%; height: 100%; object-fit: cover;
    object-position: top center; display: block;
  }
  .aj2-guest__name {
    font-family: 'Montserrat', sans-serif; font-size: 32px;
    font-weight: 700; color: #ffffff; margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .aj2-inner { padding-left: 32px; padding-right: 32px; }
    .aj2-hero { padding-top: 32px; padding-bottom: 48px; }
    .aj2-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .aj2-hero__title { font-size: 24px; }
    .aj2-hero__left { gap: 16px; }
    .aj2-guest__title { font-size: 24px; margin-bottom: 24px; }
    .aj2-guest__photo-bg { width: 260px; height: 300px; }
    .aj2-guest__name { font-size: 24px; margin-top: 18px; }
    .aj2-body__para { font-size: 14px; margin-bottom: 12px; }
    .aj2-body { padding-bottom: 48px; }
    .aj2-guest { padding-bottom: 48px; }
    .aj2-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .aj2-inner { padding-left: 16px; padding-right: 16px; }
    .aj2-hero { padding-top: 51px; padding-bottom: 30px; }
    .aj2-hero__grid { grid-template-columns: 1fr; gap: 30px; }
    .aj2-hero__left { gap: 30px; }
    .aj2-hero__title { font-size: 30px; }
    .aj2-body__para { font-size: 16px; margin-bottom: 10px; }
    .aj2-guest__title { font-size: 30px; margin-bottom: 20px; }
    .aj2-guest__photo-bg { width: 100%; height: 386px; }
    .aj2-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .aj2-body { padding-bottom: 30px; }
    .aj2-guest { padding-bottom: 30px; }
    .aj2-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("aj2-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

const YT_VIDEO_ID = "BHji1OC9gt4";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);
  if (playing) {
    return (
      <div className="aj2-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 27 Awadesh JHA Fortum Charge & Drive India"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <div
      className="aj2-yt-thumb"
      onClick={() => setPlaying(true)}
      role="button"
      aria-label="Play video"
    >
      <img src={ThumbImg} alt="EP 27 Awadesh JHA thumbnail" />
      <div className="aj2-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);
  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="aj2-hero">
      <div className="aj2-inner">
        <div className="aj2-hero__grid">
          <div className="aj2-hero__left">
            <h1 ref={titleRef} className="aj2-hero__title">
              EP 27 | Concluding the Chicken &amp; Egg story? | Awadesh JHA | Fortum Charge &amp; Drive India
            </h1>
            <div ref={spotifyRef} className="aj2-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/5haPnGxJKZ1emiKLVNfSXh?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 27 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="aj2-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="aj2-body">
      <div className="aj2-inner">
        <p className="aj2-body__para">
          This episode proved very interesting as we returned to the charge Point operations sector to speak to one of Europe's largest CPOs, Fortum.
        </p>
        <p className="aj2-body__para">
          Following its successful domination of the European market, the company is focusing on expanding its network in India, the world's fourth-largest automobile market. Fortum is among those who believe that infrastructure is required to conclude the Chicken and Egg narrative and facilitate the transition from ICE to electric vehicles.
        </p>
        <p className="aj2-body__para">
          We speak to none other than Awadhesh JHA, Executive Director for Fortum Charge &amp; Drive India.
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="aj2-guest">
      <div className="aj2-inner">
        <h2 className="aj2-guest__title">Our Guest</h2>
        <div>
          <div className="aj2-guest__photo-bg">
            <img src={GuestImg} alt="Awadesh Kumar JHA" />
          </div>
          <p className="aj2-guest__name">Awadesh Kumar JHA</p>
        </div>
      </div>
    </section>
  );
}

export default function Ep27AwadeshJha() {
  return (
    <>
      <style>{CSS}</style>
      <div className="aj2-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}